import {makeStyles} from '@mui/styles';

export const useStylesBox = makeStyles(() => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        background: 'rgba(119, 126, 144, 0.1)',
        borderRadius: '5px',
        width: '100px',
    },
    textFieldLink: {
        borderBottom: 'none',
        borderRadius: '5px',
        width: '100%',
        paddingRight: '50px',
    },
    placeholderTextField: {
        width: '160px',
    },
}),
);

export const useStyles = makeStyles(() => ({
    expanded: {},
    content: {
        '&$expanded': {
            margin: '12px 0px',
        },
    },
}));
